import { makeStyles, tokens } from '@fluentui/react-components';

export const useTroubleshootDetailDrawerStyles = makeStyles({
  body: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: tokens.spacingVerticalL,
  },
  contentSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
  },
  problemSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
  },
  problemDescription: {
    color: tokens.colorNeutralForeground2,
  },
  stepsSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
  },
  stepsHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXXS,
  },
  stepsSubtitle: {
    color: tokens.colorNeutralForeground2,
  },
  stepsTip: {
    color: tokens.colorNeutralForeground3,
  },
  stepsList: {
    display: 'flex',
    flexDirection: 'column',
  },
  stepItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    padding: '12px 0',
    borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    ':last-child': {
      borderBottom: 'none',
    },
  },
  stepDescription: {
    color: tokens.colorNeutralForeground2,
  },
  expandLink: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXXS,
    cursor: 'pointer',
  },
  expandedStepList: {
    paddingLeft: tokens.spacingHorizontalXL,
    listStyleType: 'decimal',
    listStylePosition: 'outside' as const,
  },
  chevronIcon: {
    transition: 'transform 0.2s',
  },
  chevronExpanded: {
    transform: 'rotate(90deg)',
  },
  expandNote: {
    color: tokens.colorNeutralForeground3,
    paddingLeft: tokens.spacingHorizontalS,
  },
  accordionItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
    padding: '12px 0',
    borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    ':last-child': {
      borderBottom: 'none',
    },
  },
  accordionHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    cursor: 'pointer',
  },
  accordionContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalXXL,
    color: tokens.colorNeutralForeground2,
  },
  noteText: {
    color: tokens.colorNeutralForeground3,
    whiteSpace: 'pre-line',
  },
  googleNote: {
    color: tokens.colorNeutralForeground3,
  },
  seeExampleLabel: {
    color: tokens.colorBrandForegroundLink,
  },
  seeExampleContent: {
    color: tokens.colorNeutralForeground3,
    paddingLeft: tokens.spacingHorizontalXL,
  },
  whatToDoSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
  },
  whatToDoContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
    paddingLeft: tokens.spacingHorizontalXL,
  },
  supportSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
    paddingTop: tokens.spacingVerticalL,
    borderTop: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
  },
  supportCaption: {
    color: tokens.colorNeutralForeground3,
  },
});
